import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TalentService } from 'src/app/providers/talent/talent.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { TagModel } from 'ngx-chips/core/accessor';
import { GeneralService } from 'src/app/providers/general/general.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { AuthService } from 'src/app/providers/auth/auth.service';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-job-details',
  templateUrl: './job-details.component.html',
  styleUrls: ['./job-details.component.scss']
})
export class JobDetailsComponent implements OnInit {

  public empStatus = localStorage.getItem('emp_status');
  public empEntity = localStorage.getItem('entity');
  public mrf_id: any;
  public youtubeId: any;
  public ijp_detail: any = [];
  public youtube_detail: any = [];
  public jobApplyForm: FormGroup;
  public candCv: any = [];
  public candPhoto: any = [];
  public submitted = false;
  public loading = false;
  public qualListTemp: any = [];
  public gendListTemp: any = [];
  public expListTemp: any = [];
  public expList: any = [];
  public qualList: any = [];
  public gendList: any = [];
  public result: any;
  public logId: any;
  source: any;
  ipAddress: any;
  jobsHeader: any;
  subsource: any;
  fb_share: any = '';
  source_ref: any = '';
  ijp_detail_desc:any;

  constructor(
    private route: ActivatedRoute,
    private http: TalentService,
    private router: Router,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private genHttp: GeneralService,
    private notifyService: NotificationService
  ) {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const id = params.get('id');
      this.source_ref = params.get('source');
      this.mrf_id = id;
    });
    this.getIjpDetails();
    this.fb_share = environment.backend_url + 'jobs/' + this.mrf_id;

    console.log('jobs dtls', document.referrer);
    if (document.referrer == 'https://l.facebook.com/') {
      console.log('facebook source');
    }
    console.log('this.source_ref', this.source_ref);
  }

  ngOnInit(): void {
    this.jobApplyForm = new FormGroup({
      first_name: new FormControl('', Validators.required),
      last_name: new FormControl('', Validators.required),
      email: new FormControl('', [
        Validators.email,
        Validators.pattern(
          '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$'
        ),
      ]),
      phone: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern('^[0-9]*$'),
      ]),
      aadhar_no: new FormControl('', [
        Validators.minLength(12),
        Validators.maxLength(12),
        Validators.pattern('^[0-9]*$'),
      ]),
      gender: new FormControl(''),
      compitency: new FormControl(''),
      dob: new FormControl(''),
      source: new FormControl(''),
      refer: new FormControl(''),
      cover_letter: new FormControl(''),
    });
    this.getGenderList();
    this.getYoutubeDetails();
    this.relatedJobs(this.mrf_id);
  }
  getIjpDetails(): void {
    this.authService
      .getIjpDetails(this.mrf_id, localStorage.getItem('user'))
      .subscribe((res) => {
        this.ijp_detail = res;
        this.ijp_detail = this.ijp_detail.data;
      });

      this.relatedJobs(this.mrf_id);
}

relatedJobs(mrfId): void {
  this.authService
    .getIjpDetailsDesc(this.mrf_id, localStorage.getItem('user'))
      .subscribe((res) => {
        this.ijp_detail_desc = res;
        this.ijp_detail_desc= this.ijp_detail_desc.data.data;
      });
}

  getYoutubeDetails(): void {
    this.youtubeId = 1;
    this.genHttp.getYoutube(this.youtubeId).subscribe((res) => {
      this.youtube_detail = res;
      this.youtube_detail = this.youtube_detail.data;
      //console.log(this.youtube_detail);
      //console.log(this.youtube_detail.SafeUrl);
    });
  }
  get apply() {
    return this.jobApplyForm.controls;
  }

  public findInvalidControls(): any[] {
    const invalid = [];
    const controls = this.jobApplyForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  applyJob(): void {
    this.submitted = true;
    if (this.jobApplyForm.invalid) {
      console.log(this.findInvalidControls());
      this.jobApplyForm.markAllAsTouched();

      return;
    }
    this.loading = true;
    const jobApplyFormData = new FormData();
    jobApplyFormData.append(
      'candidate_name',
      this.jobApplyForm.get('first_name').value
    );
    jobApplyFormData.append(
      'candidate_lname',
      this.jobApplyForm.get('last_name').value
    );
    jobApplyFormData.append(
      'cand_email_id',
      this.jobApplyForm.get('email').value
    );
    jobApplyFormData.append(
      'contact_num',
      this.jobApplyForm.get('phone').value
    );
    jobApplyFormData.append(
      'aadhar_no',
      this.jobApplyForm.get('aadhar_no').value
    );
    jobApplyFormData.append(
      'cand_gender',
      this.jobApplyForm.get('gender').value
    );
    jobApplyFormData.append(
      'candidate_cmpt',
      this.jobApplyForm.get('compitency').value
    );
    jobApplyFormData.append('dob', this.jobApplyForm.get('dob').value);
    jobApplyFormData.append(
      'cover_letter',
      this.jobApplyForm.get('cover_letter').value
    );

    if (
      this.source_ref == 'facebook' ||
      document.referrer == 'https://l.facebook.com/'
    ) {
      this.source = 326;
      this.subsource = 327;
    } else if (this.source_ref == 'linkedin') {
      this.source = 86;
      this.subsource = 94;
    } else if (this.source_ref == 'whatsapp') {
      this.source = 326;
      this.subsource = 349;
    } else {
      if (localStorage.getItem('entity') == '2') {
        // NGO
        this.source = 84; // NGO
        this.subsource = 0;
        // } else if (localStorage.getItem('entity') == '3') { // train & hire
        //    this.source = 84;  // train & hire
      } else if (localStorage.getItem('entity') == '1') {
        // alumia
        this.source = 231; // alumia
        this.subsource = 0;
      } else {
        this.source = 232; // apac global
        this.subsource = 0;
      }
    }

    // if(document.referrer == "https://l.facebook.com/"){
    //   console.log('facebook source');
    //   this.source = 326;
    //   this.subsource = 327;
    // } else {
    //   if (localStorage.getItem('entity') == '2') { // NGO
    //     this.source = 84;  // NGO
    //     this.subsource = 0;
    //   // } else if (localStorage.getItem('entity') == '3') { // train & hire
    //   //    this.source = 84;  // train & hire
    //   } else if (localStorage.getItem('entity') == '1') { // alumia
    //     this.source = 231;  // alumia
    //     this.subsource = 0;
    //   } else {
    //     this.source = 232;  // apac global
    //     this.subsource = 0;
    //   }
    // }

    jobApplyFormData.append('source', this.source);
    jobApplyFormData.append('source_sub_id', this.subsource);
    jobApplyFormData.append('permanent_add', 'NA');
    jobApplyFormData.append('candidate_cv', this.candCv);
    jobApplyFormData.append('candidate_img', this.candPhoto);
    jobApplyFormData.append('mrf_id', this.ijp_detail.mrf_id);
    jobApplyFormData.append('is_internal', '1');
    jobApplyFormData.append('stage_id', '1');
    jobApplyFormData.append('refer', this.jobApplyForm.get('refer').value);
    jobApplyFormData.append('user_id', localStorage.getItem('user'));
    this.authService.addCandidateIJP(jobApplyFormData, '').subscribe(
      (res) => {
        this.submitted = false;
        this.loading = false;
        this.result = res;
        if (this.result.status === true) {
          this.notifyService.showSuccess(this.result.msg, 'Success');
          this.resetJobApplyForm();
          this.jobApplyForm.reset();
          this.getIjpDetails();
        } else {
          this.notifyService.showError(this.result.msg, 'Error');
        }
      },
      (err) => {
        this.submitted = false;
        this.loading = false;
        this.notifyService.showError(err.error.msg, 'Error!');
      }
    );
  }

  resetJobApplyForm(): void {
    this.jobApplyForm.reset();
    this.candPhoto = '';
    this.candCv = '';
    $('#apply_job_modal').modal('hide');
  }
  onFileChangePhoto(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.candPhoto = file;
      $('#candEmpPhoto').html(this.candPhoto.name);
    }
  }
  onFileChangeCv(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.candCv = file;
      $('#candEmpFile').html(this.candCv.name);
    }
  }
  shareMedia1() {
    $('#socal_media').modal('show');
  }

  checkBugetfrom(num): boolean {
    if (this.isFloat(num) == true || this.isInt(num) == true) {
      return true;
    }
    return false;
  }
  isInt(n): boolean {
    return Number(n) === n && n % 1 === 0;
  }

  isFloat(n): boolean {
    return Number(n) === n && n % 1 !== 0;
  }

  getGenderList(): void {
    this.authService.getGenders().subscribe(
      (res) => {
        this.gendListTemp = res;
        this.gendList = this.gendListTemp.data;
      },
      (err) => {}
    );
  }
  addJobModal(stageId): void {
    if (stageId == '' || stageId == null || stageId == undefined) {
      this.source = '';
    } else {
      this.source = stageId;
    }
    const params = {
      user_id: localStorage.getItem('user'),
    };
    console.log(this.source);
    if (this.source == 231) {
      this.authService.getEmployeesDetails(params).subscribe((res) => {
        this.result = res;
        console.log('ijp->', this.result);
        this.jobApplyForm.patchValue({
          first_name: this.result.data.det_ijp.name,
          last_name: this.result.data.det_ijp.lname,
          email: this.result.data.det_ijp.email,
          phone: this.result.data.det_ijp.mobile,
          aadhar_no: this.result.data.det_ijp.aadhar_no,
          gender: this.result.data.det_ijp.gend_id,
          compitency: this.result.data.det_ijp.emp_cmpt,
          dob: this.result.data.det_ijp.dob,
          refer: 1,
        });
        setTimeout(() => {
          this.jobApplyForm.patchValue({
            gender: this.result.data.det_ijp.gend_id,
          });
        }, 1000);
      });
    } else {
      this.jobApplyForm.patchValue({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        aadhar_no: '',
        gender: '',
        compitency: '',
        dob: '',
        refer: 0,
      });
    }
    $('#apply_job_modal').modal({ backdrop: 'static', keyboard: false });
  }

  logout(): void {
    const params = {
      ip: this.ipAddress,
      source: 'web',
    };
    console.log('pp', params);
    const popUp = localStorage.getItem('popUp');
    const date = localStorage.getItem('date');
    const usrId = localStorage.getItem('usrId');
    const ballon = localStorage.getItem('showBallon');
    const evntDate = localStorage.getItem('eventDate');

    this.authService.logOutFromJobs(params).subscribe(
      (res) => {
        this.result = res;
        // if (this.result.status) {

        localStorage.clear();
        localStorage.setItem('popUp', popUp);
        localStorage.setItem('date', date);
        localStorage.setItem('usrId', usrId);
        localStorage.setItem('showBallon', ballon);
        localStorage.setItem('eventDate', evntDate);

        this.router.navigate(['/']);
        this.notifyService.showSuccess(this.result.msg, 'Success');
        // }
      },
      (err) => {
        localStorage.clear();
        localStorage.setItem('popUp', popUp);
        localStorage.setItem('date', date);
        localStorage.setItem('usrId', usrId);
        localStorage.setItem('showBallon', ballon);
        localStorage.setItem('eventDate', evntDate);

        this.router.navigate(['/']);
        this.notifyService.showSuccess(this.result.msg, 'Success');
      }
    );
  }
  toggleSidebar = () => {
    if ($('body').hasClass('mini-sidebar')) {
      $('body').removeClass('mini-sidebar');
      localStorage.setItem('mini-sidebar', '0');
      $('.subdrop + ul').slideDown();
    } else {
      $('body').addClass('mini-sidebar');
      localStorage.setItem('mini-sidebar', '1');
      $('.subdrop + ul').slideUp();
    }
  };
  
}

